module.exports = "/assets/data/b8727b726a0d0826b9e692b6743c99e4-BN3.data.json";